import { useState } from 'react';

import {
  IconButton,
  Td,
  Tr,
  Flex,
  Text,
  Button,
  CloseIcon,
} from '@frontend/legacy-components';

import FormattedInput from 'modules/quotes/quoteItems/components/InputComponents/InputCells/FormattedInputCell';
import InputContainer from 'modules/quotes/quoteItems/components/InputComponents/InputContainer';
import Cell from 'modules/quotes/quoteItems/components/Table/Cell';

import { formatPercent, parseDecimalString } from 'utils/formatters';

import { MULTIPLE_VALUES } from './data/constants';
import type { AnyDiscount } from './types';

export interface DiscountRowProps {
  discount: AnyDiscount;
  onRemove: (id: string) => void;
  onEdit: (id: string, data: Partial<AnyDiscount>) => void;
}

export const DiscountRow = ({
  discount,
  onEdit,
  onRemove,
}: DiscountRowProps) => {
  const [isEditingName, setIsEditingName] = useState(false);

  return (
    <Tr>
      <Td>
        <Flex alignItems="center">
          {isEditingName ? (
            <InputContainer
              initialValue={discount.name}
              onSave={(name: string) => {
                onEdit(discount.id, { name });
                setIsEditingName(false);
              }}
            />
          ) : (
            <Text as="span" flex={1}>
              {discount.name}
            </Text>
          )}
          {!isEditingName && discount.isManual && (
            <Button
              mx={1.5}
              variant="link"
              textTransform="uppercase"
              onClick={() => setIsEditingName(true)}
            >
              edit
            </Button>
          )}
          {!isEditingName && (
            <IconButton
              aria-label="Remove Discount"
              onClick={() => onRemove(discount.id)}
            >
              <CloseIcon />
            </IconButton>
          )}
        </Flex>
      </Td>
      <Cell
        as={Td}
        display="table-cell"
        revertable={!discount.isManual}
        shouldHighlightOverrides={!discount.isManual}
        border="none"
        w="unset"
        h={3}
        editable
        editableComponent={FormattedInput}
        formatter={(v: string) =>
          v === MULTIPLE_VALUES ? '(Multiple values)' : formatPercent(v)
        }
        parser={parseDecimalString}
        calculatedKey="percentage"
        manualKey="manualPercentage"
        source={discount}
        onSave={(manualPercentage: string) =>
          onEdit(discount.id, { manualPercentage })
        }
      />
    </Tr>
  );
};
